module.exports = __webpack_public_path__ + "media/images/social-share-button/wechat-28b576b3290e9cb551153e9034c02d69.svg";